module.exports = __webpack_public_path__ + "static/snap-commerce-logo-04ae2088a729b506e54e594643b311b4.jpg";